import { SET_AUTH_DATA, SET_ROLES_DATA, SET_USER, SIGN_OUT } from './types';

const initialSignInState = {
    loggedIn: false,
    loader: false,
}

const sessionState = (state = initialSignInState, action) => {
    if (action.type) {
        switch (action.type) {
            case SET_AUTH_DATA:
                return {
                    ...state,
                    role: action.payload?.role,
                    token: action.payload?.token,
                    companyDisplayName: action.payload?.companyDisplayName,
                    companyName: action.payload?.companyName,
                    menuData: action.payload?.menuData,
                    connectionName: action.payload?.connectionName,
                    isVerified: action.payload?.isVerified,
                    activeRoleId:action.payload?.activeRoleId,
                    userName: action.payload?.userName,
                }
            case SIGN_OUT:
                return {
                    ...state,
                    role: undefined,
                    token: undefined,
                    companyDisplayName: undefined,
                    companyName: undefined,
                    menuData: undefined,
                    connectionName: undefined,
                    isVerified: undefined,
                    activeRoleId: undefined,
                    userName: undefined,
                }
            case SET_ROLES_DATA:
                return {
                    ...state,
                    authData: action.payload
                }
            case SET_USER:
                return {
                    ...state,
                    userList : action.payload
                }    
            default:
                {
                    return state;
                }
        }
    }
}

export default sessionState;